import { passwordReset } from '@features/profile/components/password-and-security/helpers/passwordReset';
import { PasswordResetModal } from '@features/profile/components/password-and-security/password-reset/PasswordResetModal';
import { PASSWORD_RESET_STORAGE_KEY } from '@features/profile/components/password-and-security/PasswordAndSecurity.utils';
import { EmailExists } from '@features/register-user/components/email-exists/EmailExists';
import { RegisterUserForm } from '@features/register-user/components/register-user-form/RegisterUserForm';
import * as React from 'react';

import type { RegisterUserFormPanelProps } from './RegisterUserFormPanel.types';

import styles from './RegisterUserFormPanel.module.css';

const RegisterUserFormPanel = React.memo(
  ({
    emailExists,
    onNavigateToLanding,
    onSubmitSuccess,
    onEmailExists,
    onBackToForm,
  }: Readonly<RegisterUserFormPanelProps>): React.ReactElement => {
    const [resetPasswordModalOpen, setResetPasswordModalOpen] =
      React.useState(false);

    const handleResetPassword = React.useCallback((): void => {
      const loginHint = sessionStorage.getItem('loginHint') ?? '';
      if (localStorage.getItem(PASSWORD_RESET_STORAGE_KEY) === 'true') {
        passwordReset(loginHint);
        return;
      }
      setResetPasswordModalOpen(true);
    }, []);

    const handleCloseResetPasswordModal = React.useCallback((): void => {
      setResetPasswordModalOpen(false);
    }, []);

    const loginHint = sessionStorage.getItem('loginHint') ?? '';

    return (
      <div
        className={styles.formPanelWrapper}
        data-testid="register-user-form-panel"
      >
        {emailExists ? (
          <EmailExists
            onLoginClick={onNavigateToLanding}
            onResetPassword={handleResetPassword}
            onBackClick={onBackToForm}
          />
        ) : (
          <RegisterUserForm
            onSubmitSuccess={onSubmitSuccess}
            onEmailExists={onEmailExists}
          />
        )}
        <PasswordResetModal
          isModalOpen={resetPasswordModalOpen}
          onClose={handleCloseResetPasswordModal}
          loginHint={loginHint}
        />
      </div>
    );
  }
);

RegisterUserFormPanel.displayName = 'RegisterUserFormPanel';
export { RegisterUserFormPanel };
